/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NotificationUpdateDto,
  UINotificationResponseDto,
} from '../models/index';
import {
    NotificationUpdateDtoFromJSON,
    NotificationUpdateDtoToJSON,
    UINotificationResponseDtoFromJSON,
    UINotificationResponseDtoToJSON,
} from '../models/index';

export interface DeleteUINotificationRequest {
    id: string;
}

export interface GetUINotificationRequest {
    id: string;
}

export interface GetUINotificationsByUserIdAndIsReadRequest {
    isRead?: boolean;
}

export interface UpdateNewUINotificationRequest {
    notificationUpdateDto: NotificationUpdateDto;
}

/**
 * 
 */
export class UINotificationControllerApi extends runtime.BaseAPI {

    /**
     * Delete notification by notification id
     */
    async deleteUINotificationRaw(requestParameters: DeleteUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUINotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/notification/ui-notification/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete notification by notification id
     */
    async deleteUINotification(requestParameters: DeleteUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteUINotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notifications by notification id
     */
    async getUINotificationRaw(requestParameters: GetUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UINotificationResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUINotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/notification/ui-notification/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UINotificationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get notifications by notification id
     */
    async getUINotification(requestParameters: GetUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UINotificationResponseDto | null | undefined > {
        const response = await this.getUINotificationRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get a list of all notifications by user id
     * Get notifications by user id
     */
    async getUINotificationsByUserIdAndIsReadRaw(requestParameters: GetUINotificationsByUserIdAndIsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UINotificationResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['isRead'] != null) {
            queryParameters['is-read'] = requestParameters['isRead'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/notification/ui-notification`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UINotificationResponseDtoFromJSON));
    }

    /**
     * Get a list of all notifications by user id
     * Get notifications by user id
     */
    async getUINotificationsByUserIdAndIsRead(requestParameters: GetUINotificationsByUserIdAndIsReadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UINotificationResponseDto> | null | undefined > {
        const response = await this.getUINotificationsByUserIdAndIsReadRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Used for read notifications
     * Update status of UI notification
     */
    async updateNewUINotificationRaw(requestParameters: UpdateNewUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UINotificationResponseDto>> {
        if (requestParameters['notificationUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'notificationUpdateDto',
                'Required parameter "notificationUpdateDto" was null or undefined when calling updateNewUINotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/notification/ui-notification/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationUpdateDtoToJSON(requestParameters['notificationUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UINotificationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Used for read notifications
     * Update status of UI notification
     */
    async updateNewUINotification(requestParameters: UpdateNewUINotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UINotificationResponseDto> {
        const response = await this.updateNewUINotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
